import { gql } from '@apollo/client';

export const GET_API_KEYS_BY_TEAM = gql`
  query GetApiKeysByTeam($teamId: ID!) {
    apiKeysByTeam(teamId: $teamId) {
      id
      name
      keyPrefix
      status
      createdAt
      lastUsedAt
      expiresAt
      revokedAt
      requestCount
      createdByName
    }
  }
`;

// Lightweight team-name lookup used to label the API key create form. Kept
// minimal so we don't pull heavy TeamData just to render one line of text.
export const GET_TEAM_NAME = gql`
  query GetTeamNameForApiKeys($teamId: ID!) {
    teamById(teamId: $teamId) {
      id
      name
    }
  }
`;
